import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const dataTypes = ['texto', 'imagen', 'audio', 'video', 'documento'];

const Reminders = ({ recordatorio, archivos, refreshData, setNotification, functionesChatbot, nodos, operacion }) => {
	const [nuevoRecordatorio, setNuevoRecordatorio] = useState(recordatorio);

	useEffect(() => {
		setNuevoRecordatorio(recordatorio);
	}, [recordatorio]);

	return (
		<div style={{ width: '80%', margin: '40px auto' }}>
			<div align='right'>
				<div className='taby'>
					{recordatorio.global ? (
						recordatorio.nombre
					) : (
						<input onChange={(e) => setNuevoRecordatorio({ ...nuevoRecordatorio, nombre: e.target.value })} value={nuevoRecordatorio.nombre} />
					)}
				</div>
			</div>
			<div className='form-container'>
				{!recordatorio.global && <DestSelection nuevoRecordatorio={nuevoRecordatorio} setNuevoRecordatorio={setNuevoRecordatorio} nodos={nodos} />}
				<Scripts nuevoRecordatorio={nuevoRecordatorio} setNuevoRecordatorio={setNuevoRecordatorio} archivos={archivos} />
				<Buttons nuevoRecordatorio={nuevoRecordatorio} setNuevoRecordatorio={setNuevoRecordatorio} />
				<Conditions nuevoRecordatorio={nuevoRecordatorio} setNuevoRecordatorio={setNuevoRecordatorio} />
				<Functions nuevoRecordatorio={nuevoRecordatorio} setNuevoRecordatorio={setNuevoRecordatorio} functionesChatbot={functionesChatbot} />
				<SaveDelete nuevoRecordatorio={nuevoRecordatorio} operacion={operacion} />
			</div>
		</div>
	);
};

export default Reminders;

function toggle_variable(parametro) {
	if (parametro[0] === '&') {
		parametro = parametro.slice(1, -1);
	} else {
		parametro = '&' + parametro + '*';
	}
	return parametro;
}

//#region Seccion para la seleccion del nodo destino

function DestSelection({ nuevoRecordatorio, setNuevoRecordatorio, nodos }) {
	const [listNodos, setListNodos] = useState(nodos);

	useEffect(() => {
		setListNodos(nodos.filter((infoNodo) => !nuevoRecordatorio.nodos.some((nodo) => nodo === infoNodo.nodo)));
	}, [nuevoRecordatorio, nodos]);

	return (
		<div>
			<b>Nodos Asociados</b>
			<br />
			{nuevoRecordatorio.nodos.map((nodo, indice) => {
				const NodoActual = nodos.filter((infoNodo) => infoNodo.nodo === nodo);
				const list = NodoActual.concat(listNodos);
				return (
					<NodoAsociado
						key={indice}
						nodo={nodo}
						indice={indice}
						nodos={list}
						setNuevoRecordatorio={setNuevoRecordatorio}
						nuevoRecordatorio={nuevoRecordatorio}
					/>
				);
			})}
			<button
				onClick={() =>
					setNuevoRecordatorio({
						...nuevoRecordatorio,
						nodos: [...nuevoRecordatorio.nodos, 'none'],
					})
				}
				style={{ width: '230px' }}
				className='add-button rectangle'
			>
				+
			</button>
		</div>
	);
}

function NodoAsociado({ nodo, indice, nodos, setNuevoRecordatorio, nuevoRecordatorio }) {
	return (
		<div style={{ display: 'inline-block', width: '230px' }}>
			<select
				onChange={(e) => {
					const tmp = nuevoRecordatorio.nodos;
					tmp[indice] = Number(e.target.value);
					setNuevoRecordatorio({
						...nuevoRecordatorio,
						nodos: tmp,
					});
				}}
				value={nodo}
			>
				<option key='default' value={'none'}>
					Selecciona un Nodo...
				</option>
				{nodos.map((nodo, index) => (
					<option key={index} value={nodo.nodo}>
						Nodo {nodo.nodo} ({nodo.nombre})
					</option>
				))}
			</select>

			<button
				onClick={() => {
					const tmp = [...nuevoRecordatorio.nodos.slice(0, indice), ...nuevoRecordatorio.nodos.slice(indice + 1)];
					setNuevoRecordatorio({
						...nuevoRecordatorio,
						nodos: tmp,
					});
				}}
				className='remove-button'
				style={{ marginLeft: '20px' }}
			>
				x
			</button>
		</div>
	);
}

//#endregion

//#region Seccion de los scripts

function Scripts({ nuevoRecordatorio, setNuevoRecordatorio, archivos }) {
	return (
		<div>
			{nuevoRecordatorio.scripts.length === 0 && (
				<>
					<hr /> <b>Scripts</b>
					<br />
					<br />
				</>
			)}
			{nuevoRecordatorio.scripts &&
				nuevoRecordatorio.scripts.map((recordatorio, index) => {
					// recordatorio => {tipo:XXXX, valor:XXXX, externo:XXXX}
					switch (recordatorio.tipo) {
						case 'imagen':
							return (
								<MultimediaScript
									key={index}
									index={index}
									nuevoRecordatorio={nuevoRecordatorio}
									setNuevoRecordatorio={setNuevoRecordatorio}
									archivos={archivos.imagenes}
								/>
							);
						case 'audio':
							return (
								<MultimediaScript
									key={index}
									index={index}
									nuevoRecordatorio={nuevoRecordatorio}
									setNuevoRecordatorio={setNuevoRecordatorio}
									archivos={archivos.audios}
								/>
							);
						case 'video':
							return (
								<MultimediaScript
									key={index}
									index={index}
									nuevoRecordatorio={nuevoRecordatorio}
									setNuevoRecordatorio={setNuevoRecordatorio}
									archivos={archivos.videos}
								/>
							);
						case 'documento':
							return (
								<MultimediaScript
									key={index}
									index={index}
									nuevoRecordatorio={nuevoRecordatorio}
									setNuevoRecordatorio={setNuevoRecordatorio}
									archivos={archivos.documentos}
								/>
							);
						default:
							return <TextScript key={index} index={index} nuevoRecordatorio={nuevoRecordatorio} setNuevoRecordatorio={setNuevoRecordatorio} />;
					}
				})}
			<button
				className='add-button rectangle'
				onClick={() =>
					setNuevoRecordatorio({
						...nuevoRecordatorio,
						scripts: [...nuevoRecordatorio.scripts, { tipo: 'texto', valor: '', externo: false }],
					})
				}
			>
				+
			</button>
		</div>
	);
}

function TextScript({ index, nuevoRecordatorio, setNuevoRecordatorio }) {
	return (
		<div>
			<hr />

			<b>Script {index + 1}</b>
			<br />
			<br />
			<div>
				<textarea
					onChange={(e) => {
						const newScripts = nuevoRecordatorio.scripts;
						newScripts[index] = { tipo: 'texto', valor: e.target.value, externo: false };
						setNuevoRecordatorio({
							...nuevoRecordatorio,
							scripts: newScripts,
						});
					}}
					value={nuevoRecordatorio.scripts[index].valor}
					style={{ width: '60%', height: 64, resize: 'none' }}
				></textarea>

				<button
					onClick={() =>
						setNuevoRecordatorio({
							...nuevoRecordatorio,
							scripts: [...nuevoRecordatorio.scripts.slice(0, index), ...nuevoRecordatorio.scripts.slice(index + 1)],
						})
					}
					className='remove-button'
					style={{ position: 'absolute' }}
				>
					x
				</button>
			</div>

			<div style={{ marginTop: '10px' }}>
				<span style={{ marginRight: '5px' }}>Tipo de recordatorio</span>
				<select
					onChange={(e) => {
						const newScripts = nuevoRecordatorio.scripts;
						newScripts[index] = { tipo: e.target.value, valor: '', externo: false };
						setNuevoRecordatorio({
							...nuevoRecordatorio,
							scripts: newScripts,
						});
					}}
					value={nuevoRecordatorio.scripts[index].tipo}
				>
					{dataTypes.map((type) => (
						<option key={type} value={type}>
							{type}
						</option>
					))}
				</select>
			</div>
		</div>
	);
}

function MultimediaScript({ index, nuevoRecordatorio, setNuevoRecordatorio, archivos }) {
	return (
		<div>
			<hr />

			<b>Script {index + 1}</b>
			<br />
			<br />

			<div style={{ marginTop: '10px' }}>
				{!nuevoRecordatorio.scripts[index].externo ? (
					<select
						onChange={(e) => {
							const newScripts = nuevoRecordatorio.scripts;
							newScripts[index].valor = e.target.value;
							setNuevoRecordatorio({
								...nuevoRecordatorio,
								scripts: newScripts,
							});
						}}
						value={nuevoRecordatorio.scripts[index].valor}
					>
						<option key='' value=''>
							Selecciona un archivo
						</option>
						{archivos.map((file) => (
							<option key={file} value={file}>
								{file}
							</option>
						))}
					</select>
				) : (
					<span>
						<span style={{ marginRight: '15px' }}>URL del archivo:</span>
						<input
							style={{ width: '500px' }}
							value={nuevoRecordatorio.scripts[index].valor}
							onChange={(e) => {
								const newScripts = nuevoRecordatorio.scripts;
								newScripts[index].valor = e.target.value;
								setNuevoRecordatorio({
									...nuevoRecordatorio,
									scripts: newScripts,
								});
							}}
						/>
					</span>
				)}

				<button
					onClick={() =>
						setNuevoRecordatorio({
							...nuevoRecordatorio,
							scripts: [...nuevoRecordatorio.scripts.slice(0, index), ...nuevoRecordatorio.scripts.slice(index + 1)],
						})
					}
					className='remove-button'
					style={{ position: 'absolute' }}
				>
					x
				</button>
			</div>
			<div style={{ marginTop: '10px' }}>
				<span>¿El archivo es externo?</span>
				<input
					type='checkbox'
					checked={nuevoRecordatorio.scripts[index].externo}
					onChange={() => {
						const newScripts = nuevoRecordatorio.scripts;
						newScripts[index].externo = !newScripts[index].externo;
						newScripts[index].valor = '';
						setNuevoRecordatorio({
							...nuevoRecordatorio,
							scripts: newScripts,
						});
					}}
				/>
			</div>
			<div style={{ marginTop: '10px' }}>
				<span style={{ marginRight: '5px' }}>Tipo de recordatorio</span>
				<select
					onChange={(e) => {
						const newScripts = nuevoRecordatorio.scripts;
						newScripts[index] = { tipo: e.target.value, valor: '', externo: false };
						setNuevoRecordatorio({
							...nuevoRecordatorio,
							scripts: newScripts,
						});
					}}
					value={nuevoRecordatorio.scripts[index].tipo}
				>
					{dataTypes.map((type) => (
						<option key={type} value={type}>
							{type}
						</option>
					))}
				</select>
			</div>
		</div>
	);
}

//#endregion

//#region Seccion para la creacion de botones

function Buttons({ nuevoRecordatorio, setNuevoRecordatorio }) {
	return (
		<div>
			<br />
			<hr />
			<div>
				<b>Botones</b>
			</div>
			<div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
				{nuevoRecordatorio.botones &&
					nuevoRecordatorio.botones.map((boton, index) => {
						return (
							<div key={index} style={{ margin: 10 }}>
								<small>Opcion {index + 1}</small>
								<button
									onClick={() =>
										setNuevoRecordatorio({
											...nuevoRecordatorio,
											botones: [...nuevoRecordatorio.botones.slice(0, index), ...nuevoRecordatorio.botones.slice(index + 1)],
										})
									}
									className='remove-button'
								>
									x
								</button>
								<br />
								<input
									onChange={(e) =>
										setNuevoRecordatorio({
											...nuevoRecordatorio,
											botones: [...nuevoRecordatorio.botones.slice(0, index), e.target.value, ...nuevoRecordatorio.botones.slice(index + 1)],
										})
									}
									value={nuevoRecordatorio.botones[index]}
								></input>
							</div>
						);
					})}
				<button
					onClick={() =>
						nuevoRecordatorio.botones
							? setNuevoRecordatorio({ ...nuevoRecordatorio, botones: [...nuevoRecordatorio.botones, ''] })
							: setNuevoRecordatorio({ ...nuevoRecordatorio, botones: [''] })
					}
					className='add-button'
					style={{ width: 80, height: 80, marginTop: 10 }}
				>
					+
				</button>
			</div>
		</div>
	);
}

//#endregion

//#region Seccion para la creacion y eliminacion de condiciones

function Conditions({ nuevoRecordatorio, setNuevoRecordatorio }) {
	return (
		<div>
			<br />
			<hr />
			<div>
				<b style={{ marginRight: 20 }}>Condiciones</b>
				<div style={{ marginTop: '10px' }}>
					<h5>¿Deseas habilitar el recordatorio?</h5>
					<input
						type='checkbox'
						checked={nuevoRecordatorio.habilitado}
						onChange={() => {
							setNuevoRecordatorio({
								...nuevoRecordatorio,
								habilitado: !nuevoRecordatorio.habilitado,
							});
						}}
					/>
				</div>
				<div style={{ marginTop: '10px' }}>
					<h5>¿Cuántas veces se le debe recordar al usuario?</h5>
					<input
						type='number'
						min='-1'
						onChange={(e) => {
							if (e.target.value < -1) {
								setNuevoRecordatorio({ ...nuevoRecordatorio, numeroRecordatorios: -1 });
							} else {
								setNuevoRecordatorio({ ...nuevoRecordatorio, numeroRecordatorios: Number(e.target.value) });
							}
						}}
						value={nuevoRecordatorio.numeroRecordatorios}
					></input>
					{nuevoRecordatorio.numeroRecordatorios === 0 && (
						<div>
							<span style={{ fontSize: '12px', color: 'orange' }}>
								* Asignar el número cero no se tomará en cuenta, se le enviará al usuario el recordatorio al menos una vez. Si desea deshabilitar el
								recordatorio, por favor use la opción correspondiente *
							</span>
						</div>
					)}
					{nuevoRecordatorio.numeroRecordatorios === -1 && (
						<div>
							<span style={{ fontSize: '12px', color: 'orange' }}>
								* Asignar el valor "-1" a esta opción indicará al robot que se envíe el recordatorio infinitamente hasta que el usuario reanude su
								conversación *
							</span>
						</div>
					)}
				</div>
				<div style={{ marginTop: '10px' }}>
					<h5>¿Cuántos minutos debe esperar el robot para mandar el recordatorio?</h5>
					<input
						type='number'
						min='1'
						onChange={(e) => {
							if (e.target.value < 1) {
								setNuevoRecordatorio({ ...nuevoRecordatorio, tiempoEspera: 1 });
							} else {
								setNuevoRecordatorio({ ...nuevoRecordatorio, tiempoEspera: Number(e.target.value) });
							}
						}}
						value={nuevoRecordatorio.tiempoEspera}
					></input>
				</div>
			</div>
		</div>
	);
}

//#endregion

//#region Seccion para la asignacion de funciones

function Functions({ nuevoRecordatorio, setNuevoRecordatorio, functionesChatbot }) {
	const funcionDefault = { nombreFuncion: '', guardarEn: '', parametros: [] };
	return (
		<div>
			<br />
			<hr />

			{!(nuevoRecordatorio.ejecutaFuncion && nuevoRecordatorio.ejecutaFuncion.length > 0) && (
				<div>
					<b>Funciones que Ejecuta </b>
				</div>
			)}
			<div>
				{nuevoRecordatorio.ejecutaFuncion &&
					nuevoRecordatorio.ejecutaFuncion.map((funcion, index) => {
						return (
							<div key={index} style={{ margin: 10, textAlign: 'center' }}>
								<hr style={{ borderWidth: '2px' }} />
								<h2>Función número {index + 1}</h2>
								<h3>- {funcion.nombreFuncion} -</h3>
								<button
									onClick={() => {
										const temp = { ...nuevoRecordatorio };

										if (temp.ejecutaFuncion.length === 1) {
											delete temp.ejecutaFuncion;
										} else {
											temp.ejecutaFuncion = [...temp.ejecutaFuncion.slice(0, index), ...temp.ejecutaFuncion.slice(index + 1)];
										}

										setNuevoRecordatorio(temp);
									}}
									className='remove-button'
									style={{ marginLeft: '0px' }}
								>
									x
								</button>
								<br />
								<small>Nombre de la función</small>
								<br />
								{/* <input
									onChange={(e) =>
										setNuevoRecordatorio({
											...nuevoRecordatorio,
											ejecutaFuncion: [
												...nuevoRecordatorio.ejecutaFuncion.slice(0, index),
												{ ...nuevoRecordatorio.ejecutaFuncion[index], nombreFuncion: e.target.value },
												...nuevoRecordatorio.ejecutaFuncion.slice(index + 1),
											],
										})
									}
									value={nuevoRecordatorio.ejecutaFuncion[index].nombreFuncion}></input> */}
								<select
									onChange={(e) =>
										setNuevoRecordatorio({
											...nuevoRecordatorio,
											ejecutaFuncion: [
												...nuevoRecordatorio.ejecutaFuncion.slice(0, index),
												{ ...nuevoRecordatorio.ejecutaFuncion[index], nombreFuncion: e.target.value },
												...nuevoRecordatorio.ejecutaFuncion.slice(index + 1),
											],
										})
									}
									value={nuevoRecordatorio.ejecutaFuncion[index].nombreFuncion}
								>
									<option key='' value=''>
										Selecciona un archivo
									</option>
									{functionesChatbot.map((funcion) => (
										<option key={funcion} value={funcion}>
											{funcion}
										</option>
									))}
								</select>
								<br />
								<small>Parámetros</small>
								<br />
								{funcion.parametros &&
									funcion.parametros.map((parametro, index2) => {
										return (
											<div key={index2}>
												<input
													onChange={(e) =>
														setNuevoRecordatorio({
															...nuevoRecordatorio,
															ejecutaFuncion: [
																...nuevoRecordatorio.ejecutaFuncion.slice(0, index),
																{
																	...nuevoRecordatorio.ejecutaFuncion[index],
																	parametros: [
																		...nuevoRecordatorio.ejecutaFuncion[index].parametros.slice(0, index2),
																		e.target.value,
																		...nuevoRecordatorio.ejecutaFuncion[index].parametros.slice(index2 + 1),
																	],
																},
																...nuevoRecordatorio.ejecutaFuncion.slice(index + 1),
															],
														})
													}
													value={nuevoRecordatorio.ejecutaFuncion[index].parametros[index2]}
												/>

												<button
													onClick={() =>
														setNuevoRecordatorio({
															...nuevoRecordatorio,
															ejecutaFuncion: [
																...nuevoRecordatorio.ejecutaFuncion.slice(0, index),
																{
																	...nuevoRecordatorio.ejecutaFuncion[index],
																	parametros: [
																		...nuevoRecordatorio.ejecutaFuncion[index].parametros.slice(0, index2),
																		toggle_variable(nuevoRecordatorio.ejecutaFuncion[index].parametros[index2]),
																		...nuevoRecordatorio.ejecutaFuncion[index].parametros.slice(index2 + 1),
																	],
																},
																...nuevoRecordatorio.ejecutaFuncion.slice(index + 1),
															],
														})
													}
													className='toggle-button'
													style={{ wordWrap: 'unset' }}
												>
													{parametro[0] === '&' ? 'Convertir a constante' : 'Convertir a variable'}
												</button>

												<button
													onClick={() => {
														const aristaTemp = { ...nuevoRecordatorio };
														const funcion = aristaTemp.ejecutaFuncion[index];

														funcion.parametros = [...funcion.parametros.slice(0, index2), ...funcion.parametros.slice(index2 + 1)];

														aristaTemp.ejecutaFuncion[index] = funcion;

														setNuevoRecordatorio(aristaTemp);
													}}
													className='remove-button'
													style={{ marginLeft: '5px' }}
												>
													x
												</button>
											</div>
										);
									})}
								<button
									onClick={() =>
										setNuevoRecordatorio({
											...nuevoRecordatorio,
											ejecutaFuncion: [
												...nuevoRecordatorio.ejecutaFuncion.slice(0, index),
												{
													...nuevoRecordatorio.ejecutaFuncion[index],
													parametros: nuevoRecordatorio.ejecutaFuncion[index].parametros
														? [...nuevoRecordatorio.ejecutaFuncion[index].parametros, '']
														: [''],
												},
												...nuevoRecordatorio.ejecutaFuncion.slice(index + 1),
											],
										})
									}
									className='add-button rectangle'
								>
									+
								</button>
							</div>
						);
					})}
				<button
					onClick={() =>
						nuevoRecordatorio.ejecutaFuncion
							? setNuevoRecordatorio({
									...nuevoRecordatorio,
									ejecutaFuncion: [...nuevoRecordatorio.ejecutaFuncion, funcionDefault],
							  })
							: setNuevoRecordatorio({ ...nuevoRecordatorio, ejecutaFuncion: [funcionDefault] })
					}
					className='add-button square'
				>
					+
				</button>
			</div>
		</div>
	);
}

//#endregion

//#region Seccion de los botones para guardado

function SaveDelete({ nuevoRecordatorio, operacion }) {
	const history = useHistory();

	// Las validaciones deben de regresar true cuando algo no esta validado

	// Se valida que se haya asociado al menos a un nodo
	const nombreValidation = nuevoRecordatorio.nombre === '';

	// Se valida que se haya asociado al menos a un nodo
	const nodoAsociadoValidation = !nuevoRecordatorio.global && nuevoRecordatorio.nodos.length === 0;

	// Se valida que los nodos asociados sean validos
	const nodoAsociadoValidation2 = !nuevoRecordatorio.global && nuevoRecordatorio.nodos.some((nodo) => nodo === 'none');

	// Se valida que se haya definido al menos un script de mensaje
	const recordatorioValidation = nuevoRecordatorio.scripts.length === 0;

	// Se valida que se hayan definido los scripts correctamente
	const recordatorioEmptyValidation = !nuevoRecordatorio.scripts.every((recordatorio) => recordatorio.valor !== '');

	// Se valida que no haya funciones con nombres vacios
	const functionsValidation = nuevoRecordatorio.ejecutaFuncion ? !nuevoRecordatorio.ejecutaFuncion.every((funcion) => funcion.nombreFuncion !== '') : false;

	return (
		<div>
			<div className='form-actions' align='right'>
				<button className='form-button secondary-button' onClick={() => history.push('/scripts')}>
					Cancelar
				</button>
				<button
					disabled={
						nombreValidation ||
						nodoAsociadoValidation ||
						nodoAsociadoValidation2 ||
						recordatorioValidation ||
						functionsValidation ||
						recordatorioEmptyValidation
					}
					onClick={() => {
						operacion(nuevoRecordatorio);
					}}
					className='form-button primary-button'
				>
					Guardar
				</button>
			</div>

			{nombreValidation && (
				<div align='right'>
					<span style={{ fontSize: '12px', color: 'red' }}>* Se debe especificar un nombre *</span>
				</div>
			)}

			{nodoAsociadoValidation && (
				<div align='right'>
					<span style={{ fontSize: '12px', color: 'red' }}>* Se debe asociar al menos un nodo *</span>
				</div>
			)}

			{nodoAsociadoValidation2 && (
				<div align='right'>
					<span style={{ fontSize: '12px', color: 'red' }}>* Existe uno o más nodos asociados inválidos *</span>
				</div>
			)}

			{recordatorioValidation && (
				<div align='right'>
					<span style={{ fontSize: '12px', color: 'red' }}>* Debe existir al menos un script *</span>
				</div>
			)}

			{recordatorioEmptyValidation && (
				<div align='right'>
					<span style={{ fontSize: '12px', color: 'red' }}>* Existen scripts que no se encuentran definidos *</span>
				</div>
			)}

			{functionsValidation && (
				<div align='right'>
					<span style={{ fontSize: '12px', color: 'red' }}>* Existen funciones sin nombre *</span>
				</div>
			)}
		</div>
	);
}

//#endregion
